import { createContext as t, useContext as e } from "react";
import { a as o } from "../../../../vanilla-CSAfDK5R.js";
const a = () => ({
  sizeAtom: o("md")
}), r = t(a()), x = () => e(r);
export {
  r as TextCardContext,
  a as createTextCardState,
  x as useTextCardStateAtoms
};
//# sourceMappingURL=index.js.map
